module.exports = __webpack_public_path__ + "videos/odeon-desktop.565f6f8.mp4";